/**
 * This component assumes the use of Woo Variation Gallery plugin.
 * We extend its functionality to allow selecting specific slide based on current composite configuration
 *
 * @url https://wordpress.org/plugins/woo-variation-gallery/
 */
export default new class {

  init () {
    if (!window._gallery_extra) {
      // return
    }
    this.debug = false
    if (window._gallery_debug === true) {
      this.debug = true
    }
    this.$activeVariation = null
    this.config = window._gallery_extra;

    $(document).on('woo_variation_gallery_loaded', (event, gallery) => {
     this.gallery = gallery;
      this.$mainSlider = this.gallery.$slider;
    });
    
    if (this.debug) {
      this.initDebug()
    }

    // Refer to composite.js file on this event trigger
    $(document).on('comf.gallery.update', (event, component) => {
      if (!this.gallery) {
        return
      }
      window._gallery = this.gallery
      let selection = this.getSelection(component)
      let found = this.findSlide(selection)
     
      this.removeExisting()
      if (this.debug) {
        this.updateDebug({selection, found})
      }
      if (!found) {
        return
      }
      this.make(found)
    })
  }

  /**
   * Retrieve existing component selection
   * @param {WC_Component} component
   * @return {Array}
   */
  getSelection (component) {
    const components = component.composite.get_components()
    return components.map(item => {
      return parseInt(item.get_selected_product())
    })
  }

  /**
   * Retrieve image slide information based on given selection
   * This may return null if no applicable slide found
   * @param {Array} selection
   * @return {Array|null}
   */
  findSlide (selection) {
    for (let index = 0; index < this.config.length; index++) {
      const config = this.config[index];
      if (this.isEqual(config.ids, selection)) {
        return config
      }
    }
    // Second pass, checking if is subset of selection
    for (let index = 0; index < this.config.length; index++) {
      const config = this.config[index];
      if (this.arrayContainsArray(config.ids, selection)) {
        return config
      }
    }
    return null
  }

  /**
   * Returns TRUE if the first specified array contains all elements
   * from the second one. FALSE otherwise.
   *
   * @param {array} subset
   * @param {array} superset
   *
   * @returns {boolean}
   */
  arrayContainsArray (subset, superset) {
    if (0 === subset.length) {
      return false;
    }
    return subset.every(function (value) {
      return (superset.indexOf(value) >= 0);
    });
  }

  /**
   * Checks if two arrays contain the same values,
   * disregarding their order
   *
   * @param {Array} A
   * @param {Array} B
   * @return {Boolean}
   */
  isEqual (A, B) {
    // all objects in A are contained in B (A ⊆ B)
    // you can compare a <-> b however you'd like (here just `a === b`)
    let AsubB = A.every(a => B.some(b => a === b));

    // A and B are the same length
    let sameLength = A.length === B.length;

    // their contents are as equal as previously tested:
    return AsubB && sameLength;
  }

  /**
   * Slide to given attachment id
   * @param {Integer} imageId
   */
  slideTo(imageId) {
    let $slide = $(`.js-attachment-${imageId}`)
    if (!$slide.length) {
      return
    }
    let index = $slide.data('slick-index')
    this.gallery.$slider.slick('slickGoTo', index)
  }

  /**
   * Creates a new slide in the main gallery and slide to it
   * @param {Object} config
   */
  make (config) {
    if (!this.gallery) {
      return
    }
    const { image_large, image_thumb } = config
    const $slideLarge = $(image_large).attr('data-selection-variation', true)
    const $slideThumb = $(image_thumb).attr('data-selection-variation', true)
    // const { slideCount } = this.gallery.$slider.slick('getSlick')
    // let index = slideCount - 1
    this.gallery.$slider.slick('slickAdd', $slideLarge, 0, true)
    if (this.hasThumb()) {
      this.gallery.$thumbnail.slick('slickAdd', $slideThumb, 0, true)
    }
    this.$activeVariation = {
      $thumb: $slideThumb,
      $large: $slideLarge,
    }
    setTimeout(() => {
      this.gallery.$slider.slick('slickGoTo', 0)
      if (this.hasThumb()) {
        this.gallery.$thumbnail.slick('slickGoTo', 0)
      }
    }, 500);
  }

  removeExisting () {
    if (!this.$activeVariation) {
      return
    }
    let {$thumb} = this.$activeVariation
    const index = $thumb.data('slick-index')
    this.gallery.$slider.slick('slickRemove', index)
    if (this.hasThumb()) {
      this.gallery.$thumbnail.slick('slickRemove', index)
    }
  }

  hasThumb () {

    return this.gallery.$thumbnail.hasClass('slick-initialized')
  }

  initDebug () {
    let items = []
    window._gallery_extra.forEach(item => {
      let variations = item.ids.map(id => {
        return `
          <div class='mx-1 text-gray-700 text-xs'>
            ${item.mapping[id].title}
          </div>
        `
      })
      items.push(`
        <div class='w-full flex items-center mb-1 border js-gallery-debug'
          data-gallery-image-id='${item.image_id}'>
          <div class='w-8 h-8 rounded-full relative mr-1'>
            ${item.image_large}
          </div>
          ${variations.join(' + ')}
        </div>
      `)
    })
    $('form.composite_form')
      .after(`
        <div class='p-4 bg-gray-100 rounded-sm'>
        ${items.join(' ')}
        </div>
      `)
  }

  updateDebug ({ found }) {
    $('.js-gallery-debug')
      .removeClass('opacity-100 border-red-300')
      .addClass('opacity-25 border-gray-300')
    if (!found) {
      return
    }
    let imageId = found.image_id
    $(`[data-gallery-image-id='${imageId}']`)
      .removeClass('opacity-25 border-gray-300')
      .addClass('opacity-100 border-red-300')
  }

}



// WEBPACK FOOTER //
// ./scripts/components/gallery-extension.js